import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PreferredBrandsApi } from "apis/PreferredBrandsApi";
import { PreferredBrandsSearchFilterQuery } from "models/filters/preferredBrands/PreferredBrandsSearchFilterQuery";
import { PreferredBrandAddUpdate, PreferredBrandView } from "models/dbModels/preferredBrands/PreferredBrand";

export const getPreferredBrands = createAsyncThunk("preferredBrandsSlice/getPreferredBrands", async (params: PreferredBrandsSearchFilterQuery) => {
    const response = await PreferredBrandsApi.Search(params);
    return response.data;
});

//TODO: Join the above with this call. Both call the same thing, but one has a different case, so don"t know if its possible, but would be good
export const getPreferredBrandDetails = createAsyncThunk("preferredBrandsSlice/getPreferredBrandDetails", async (params: PreferredBrandsSearchFilterQuery) => {
    const response = await PreferredBrandsApi.Search(params);
    return response.data;
});

export const createPreferredBrand = createAsyncThunk("preferredBrandsSlice/createPreferredBrand", async (params: PreferredBrandAddUpdate) => {
    const response = await PreferredBrandsApi.Add([params]);
    return response.data;
});

export const updatePreferredBrand = createAsyncThunk("preferredBrandsSlice/updatePreferredBrand", async (params: PreferredBrandAddUpdate) => {
    const response = await PreferredBrandsApi.Update([params]);
    return response.data;
});

export const deletePreferredBrand = createAsyncThunk("preferredBrandsSlice/deletePreferredBrand", async (preferredBrandIds: number[]) => {
    const response = await PreferredBrandsApi.Delete({ ids: preferredBrandIds });
    return response.data;
});


export type InitialStateType = {
    id: number;
    name: string;
    pbsManufacturers: any[];
    stock: any[];
    preferredStock: any[];
    stores: any[];
    storesList: any[];
    storesTable: any[];
    sentStoreList: any[];
    selectedRows: any[];
    selectedStoresRows: any[];
    selectedStocksRows: any[];
    selectedCategoryRows: any[];
    genericCategoriesList: any[];
    genericCategoriesTable: any[];
    genericCategoriesStock: any[];
    selectedGenericCategory: string;
    selectedManufacturersRows: any[];
    selectedgenericCategoriesStock: any[];
    loading: boolean;
    error: string;
    table: PreferredBrandView[];
    mainGenericCategoriesTable: any[];
}

const initialState: InitialStateType = {
    id: 0,
    name: "",
    pbsManufacturers: [],
    stock: [],
    preferredStock: [],
    stores: [],
    storesList: [],
    storesTable: [],
    sentStoreList: [],
    selectedRows: [],
    selectedStoresRows: [],
    selectedStocksRows: [],
    selectedCategoryRows: [],
    genericCategoriesList: [],
    genericCategoriesTable: [],
    genericCategoriesStock: [],
    selectedGenericCategory: "",
    selectedManufacturersRows: [],
    selectedgenericCategoriesStock: [],
    loading: false,
    error: "",
    table: [],
    mainGenericCategoriesTable: [],
};

const preferredBrandsSlice = createSlice({
    name: "preferredBrandsSlice",
    initialState: {
        ...initialState
    },
    reducers: {
        cleanPreferredBrands: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
        updatePreferredBrandField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPreferredBrands.pending, (state) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getPreferredBrands.fulfilled, (state, action) => {
            state.loading = false;
            state.table = action.payload.data ? action.payload.data : [];
        });
        builder.addCase(getPreferredBrands.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
        builder.addCase(getPreferredBrandDetails.pending, (state) => {
            return {
                ...state,
                ...initialState,
                loading: true,
            };
        });
        builder.addCase(getPreferredBrandDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.name = action.payload.data[0].name;
            state.id = action.payload.data[0].id;
            state.pbsManufacturers = action.payload.data[0].preferredManufacturers.sort((a: any, b: any) => a.rank - b.rank);
            state.stock = action.payload.data[0].preferredStock.sort((a: any, b: any) => a.rank - b.rank);
            state.stores = action.payload.data[0].stores;
            state.selectedGenericCategory = action.payload.data[0].preferredStock.length > 0 ? action.payload.data[0].preferredStock[0].genericCategoryId : "";
        });
        builder.addCase(updatePreferredBrand.pending, (state, action) => {
            state.loading = true;
            state.pbsManufacturers = [];
            state.stock = [];
            state.stores = [];
            state.error = "";
        });
    },
});

export const { cleanPreferredBrands, updatePreferredBrandField } = preferredBrandsSlice.actions;

export default preferredBrandsSlice.reducer;